import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Tooltip from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Tooltip';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import { withStyles, makeStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { capitalize } from '@material-ui/core';

const styles = (theme) => ({
  root: {
    borderRadius: theme.radius.md,
    padding: theme.spacing(0, 2),
    userSelect: 'none',
  },
  rootBackgroundColorBlue: {},
  rootBackgroundColorOrange: {},
  rootBackgroundColorGreen: {},
  rootBackgroundColorBlack: {},
});

const getRootBackgroundColor = (backgroundColor) => {
  return {
    backgroundColor,
  };
};

const useCustomStyles = makeStyles(theme => ({
  rootBackgroundColorBlack: getRootBackgroundColor(theme.palette.common.black),
  rootBackgroundColorRed: getRootBackgroundColor(theme.palette.facet.red),
  rootBackgroundColorOrange: getRootBackgroundColor(theme.palette.facet.orange),
  rootBackgroundColorGreen: getRootBackgroundColor(theme.palette.facet.accentGreen),
  rootBackgroundColorBlue: getRootBackgroundColor(theme.palette.facet.primaryBlue),
  rootBackgroundColorPurple: getRootBackgroundColor(theme.palette.facet.purple),
}));

function getDetails(searchResultResource) {
  const statusPrompt = searchResultResource.selectedOptionPrompt('householdStatus');
  const escalationPrompt = searchResultResource.selectedOptionPrompt('householdEscalationType');

  // If a household is in a churned state
  if (searchResultResource.attr('householdStatus') === '4') {
    return { backgroundColor: 'black', tooltip: `${statusPrompt}` };
  }

  if (searchResultResource.attr('householdEscalationType') === 'save') {
    return { backgroundColor: 'red', tooltip: `${statusPrompt} (${escalationPrompt})` };
  }

  if (searchResultResource.attr('householdEscalationType') !== 'notEscalated') {
    return { backgroundColor: 'orange', tooltip: `${statusPrompt} (${escalationPrompt})` };
  }

  switch (searchResultResource.attr('householdStatus')) {
    case '2': // Active
      return { backgroundColor: 'green', tooltip: `${statusPrompt}` };
    case '4':
      throw new Error('Should already be caught above');
    case '1': // Prospect
      return { backgroundColor: 'blue', tooltip: `${statusPrompt}` };
    default:
      return { backgroundColor: 'purple', tooltip: `${statusPrompt}` };
  }
}

const HouseholdIndicator = ({
  className,
  classes,
  searchResultResource,
}) => {
  const { backgroundColor, tooltip } = getDetails(searchResultResource);
  const customClasses = useCustomStyles();

  return (
    <Tooltip
      className={classes.tooltip}
      title={tooltip}
    >
      <Typography
        className={classNames(classes.root, className, customClasses[`rootBackgroundColor${capitalize(backgroundColor)}`])}
        color={'white'}
      >
        {searchResultResource.attr('householdId')}
      </Typography>
    </Tooltip>
  );
};

HouseholdIndicator.defaultProps = {
  className: '',
};

HouseholdIndicator.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  searchResultResource: PropTypes.object.isRequired,
};

export default withStyles(styles)(HouseholdIndicator);
